import * as React from "react";
import Popper from "@d8660091/react-popper";
export default function Tooltip(props) {
    return (React.createElement(Popper, { options: {
            placement: "bottom-start"
        }, renderRef: function (_a) {
            var setReference = _a.setReference, open = _a.open, close = _a.close;
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: props.className, ref: setReference, onMouseEnter: open, onMouseLeave: close }, props.children)));
        }, renderPop: function (_a) {
            var setPop = _a.setPop;
            return (React.createElement("div", { ref: setPop, className: "sui-tooltip" },
                props.icon,
                props.title));
        } }));
}
//# sourceMappingURL=Tooltip.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Tooltip/Tooltip.js
// module id = 1779
// module chunks = 17